import urls from '@/navigation/urls'
import { INotificationWsMessage } from '@/services/Notification/notifications.types.ts'
import Button from '@/shared/Buttons/Button'
import { useNavigate } from 'react-router-dom'

interface IProps {
  notification: INotificationWsMessage
  onCancel: () => void
}

const NotificationActions = (props: IProps) => {
  const navigate = useNavigate()
  switch (true) {
    case props.notification.type === 'ALARM_SITUATION_INCIDENT':
    case props.notification.type === 'LIFT_ERROR':
      const equipmentId =
        props.notification.type === 'ALARM_SITUATION_INCIDENT'
          ? props.notification.payload.equipmentId
          : props.notification.payload.metadata.equipmentIds[0]
      return (
        <>
          <Button size="default" type="default" text="Закрыть" onClick={props.onCancel} />
          <Button
            size="default"
            type="primary"
            text="Перейти к устройству"
            onClick={() => {
              navigate(`/equipment/lifts/${equipmentId}`)
              props.onCancel()
            }}
          />
        </>
      )
    case props.notification.type === 'MAINTENANCE_OVERDUE_FACT':
    case props.notification.type === 'MAINTENANCE_OVERDUE_WARNING':
      return (
        <>
          <Button size="default" type="default" text="Закрыть" onClick={props.onCancel} />
          <Button
            size="default"
            type="primary"
            text="Показать в Календаре ТО"
            onClick={() => {
              navigate(urls.calendar)
              props.onCancel()
            }}
          />
        </>
      )
    default:
      return null
  }
}

export default NotificationActions
